export default __webpack_public_path__ + "static/media/The Might of Arctos.e0fcebd4.jpg";